<div class="pagination-container">
  <div *ngFor="let item of items; let i = index" (click)="selected(i)" class="dot-click-area">
    <div class="pagination-dot" [ngClass]="{'dot-active':isDotActive(i)}"></div>
  </div>
</div>
